
import Clock from "../../../assets/filled/Clock.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ClockIcon({ className, dataTestid = "ClockIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Clock data-testid={dataTestid} className={classes} {...rest} />
  );
}
